import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { TokenHasExpiredComponent } from 'src/app/core/components/token-has-expired/token-has-expired.component';
import { allLocalStorage } from '../constantes';
import { DigoService } from 'src/app/services/digo.service';
import { Injector } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    dialogTokenHasExpired: any = null;
    tokenExpiredLogged = false;

    constructor(public dialog: MatDialog, private injector: Injector
    ) {
    }

    private parseJwt(token): any {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        } catch(error) {
            return false;
        }
    }

    /**
     * Base URL del servidor Legacy (DF-206).
     * Lee data.legacy_url del JWT en localStorage (también si el token está expirado)
     * y normaliza con trailing slash. Si no hay claim usable, usa environment.digoEndPoint.
     */
    getLegacyBaseUrl(): string {
        const token = localStorage.getItem(allLocalStorage.accessToken);
        const payload = token ? this.parseJwt(token) : false;
        const legacyUrl = payload && payload.data ? payload.data.legacy_url : undefined;

        if (typeof legacyUrl === 'string' && legacyUrl.trim() !== '') {
            return this.normalizeLegacyBaseUrl(legacyUrl.trim());
        }

        return this.normalizeLegacyBaseUrl(environment.digoEndPoint);
    }

    private normalizeLegacyBaseUrl(url: string): string {
        return url.endsWith('/') ? url : `${url}/`;
    }

    checkIfTokenHasExpired(): boolean {
        const access_token = localStorage.getItem(allLocalStorage.accessToken);

        if (access_token && access_token !== '') {
            const jwt = this.parseJwt(access_token);
            if (!jwt) {
                console.error('Token mal formado:', access_token);
                return true;
            }
            const exp = jwt.exp * 1000;

            return new Date().getTime() >= exp;
        }

        console.error('Valor token: ', access_token);
        return true;
    }

     getToken(): string {
        if (this.checkIfTokenHasExpired()) {
            
            if(!this.tokenExpiredLogged) {
                this.tokenExpiredLogged = true;
                console.error('JWT expired');
                this.digoService.sendLogExpiredToken();
            }
            
            
            if (this.dialogTokenHasExpired == null) {
                this.dialogTokenHasExpired = this.dialog.open(TokenHasExpiredComponent, {
                    // position: {top: '300px'},
                    width: '350px',
                    disableClose: true
                });
            }

            return;
        }

        this.tokenExpiredLogged = false;
        return localStorage.getItem(allLocalStorage.accessToken);
    }

    get digoService(): DigoService {
        return this.injector.get(DigoService);
    }
}
